import {languages} from '../IntManager';

export const APP_LOADING_DATA = '@app/state/loading';
export const APP_LANGUAGE = '@app/state/language';
export const APP_MAIN_PAGE_INDEX = '@app/state/mainPageIndex';
export const APP_CAME_FROM_SLIDE = '@app/state/cameFromSlide';

const initialState = {
    language: languages.defaultLanguage,
    loadingData: false,
    mainPageIndex: 0,
    cameFromSlide: false,
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case APP_LOADING_DATA: {
            return Object.assign({}, state, {loadingData: action.value});
        }
        case APP_LANGUAGE: {
            return Object.assign({}, state, {language: action.value});
        }
        case APP_MAIN_PAGE_INDEX: {
            return Object.assign({}, state, {mainPageIndex: action.value});
        }
        case APP_CAME_FROM_SLIDE: {
            return Object.assign({}, state, {cameFromSlide: action.value});
        }
        default:
            return state;
    }
}

export const setLanguage = (value) => {
    return {
        type: APP_LANGUAGE,
        value,
    }
};

export const setMainPageIndex = (value) => {
    return {
        type: APP_MAIN_PAGE_INDEX,
        value,
    }
};

export const setCameFromSlide = (value) => {
    return {
        type: APP_CAME_FROM_SLIDE,
        value,
    }
};


// WEBPACK FOOTER //
// ./src/js/reducers/app.js